<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner page-content">
    <div class="title-wrapper">
      <div>
        <h1 class="title-default">Fórmulas de custo e preço de venda</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" class="icon-mat-symbols-btn" aria-label="Voltar" (click)="cancelar()">
            <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
          </button>
          Defina como o custo de aquisição é apurado na NF de entrada e como o preço de venda é formado a partir dele.
        </p>
      </div>
    </div>

    @if (isLoading) {
      @for (item of [1, 2]; track item) {
        <section class="section-container formula-skeleton">
          <div class="section-title">
            <app-loading-box height="24" width="190"></app-loading-box>
            <app-loading-box class="ms-auto" height="32" width="190"></app-loading-box>
          </div>
          <app-loading-box height="64" width="1000" marginTop="24"></app-loading-box>
        </section>
      }
    } @else {
      @for (contexto of contextos; track contexto.chave) {
        <section class="section-container">
          <div class="section-title">
            <mat-icon class="material-symbols-outlined">{{ iconeSecao(contexto) }}</mat-icon>
            <span>{{ nomeSecao(contexto) }}</span>
            <div class="section-title-actions ms-auto">
              <span class="disabled-action-tooltip"
                [matTooltip]="'A simulação estará disponível quando o catálogo de fórmulas for carregado.'"
                [matTooltipDisabled]="possuiFormulas(contexto)">
                <button mat-button type="button" class="btn-section" [disabled]="catalogoIndisponivel || !possuiFormulas(contexto)" (click)="simular(contexto)">
                  <mat-icon>science</mat-icon>
                  Simular cálculo
                </button>
              </span>
              <span class="disabled-action-tooltip"
                [matTooltip]="!podeAlterar ? 'Você não possui permissão para personalizar estas fórmulas.' : ''"
                [matTooltipDisabled]="podeAlterar">
                <button mat-button type="button" class="btn-section"
                  [matBadge]="contarPersonalizadas(contexto)"
                  [matBadgeHidden]="contarPersonalizadas(contexto) === 0"
                  [disabled]="!podeAlterar || catalogoIndisponivel || configuracaoIndisponivel || !possuiFormulas(contexto)"
                  (click)="personalizar(contexto)">
                  <mat-icon>settings</mat-icon>
                  Personalizar fórmulas
                </button>
              </span>
            </div>
          </div>

          @for (descricao of descricoesSecao(contexto); track descricao) {
            <p [innerHTML]="descricao"></p>
          }

          <div class="formula-list">
            @for (formula of listarFormulas(contexto); track formula.chaveFormula) {
              <mat-expansion-panel class="formula-grupo-panel" [hideToggle]="true" [expanded]="isExpandida(formula.chaveFormula)"
                (opened)="expandir(formula.chaveFormula)" (closed)="recolher(formula.chaveFormula)">
                <mat-expansion-panel-header class="formula-grupo-header">
                  <mat-panel-title class="formula-grupo-titulo">
                    <div class="formula-tags">
                      <span class="status-badge badge-variavel" [ngClass]="classeVariavel(formula)">
                        @if (isParametro(formula)) {
                          <span class="material-symbols-outlined" aria-label="Parâmetro de configuração" title="Parâmetro de configuração">settings</span>
                        }
                        @if (formula.variavelSaida.possuiFormulaAplicavel) {
                          <span class="material-symbols-outlined" aria-label="Possui fórmula aplicável" title="Possui fórmula aplicável">function</span>
                        }
                        {{ formula.variavelSaida.descricao }}
                        <span>{{ '{' + formula.variavelSaida.nome + '}' }}</span>
                      </span>
                      <span class="status-badge badge-roxo">Modelo {{ formula.configuracaoEfetiva.modelo ?? 'padrão' }}</span>
                      <span class="status-badge badge-teal">Padrão do sistema</span>
                      @if (formula.configuracaoEfetiva.isPersonalizada) { <span class="status-badge badge-vinho">Personalizada</span> }
                    </div>
                  </mat-panel-title>
                  <mat-panel-description class="formula-grupo-descricao">
                    <span class="formula-expandir-texto">
                      {{ isExpandida(formula.chaveFormula) ? 'Ocultar cálculo' : 'Ver como o sistema calcula' }}
                    </span>
                    <mat-icon class="material-symbols-outlined formula-expandir-icone" aria-hidden="true">
                      {{ isExpandida(formula.chaveFormula) ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <app-formula-card [formula]="mapearFormulaCard(formula)" [mostrarCabecalho]="false" [mostrarVigencia]="false" [mostrarBadgeModelo]="false"></app-formula-card>
              </mat-expansion-panel>
            }
          </div>
        </section>
        @if (ehSecaoPrecoVenda(contexto)) {
          <mat-form-field appearance="outline" class="markup-field" subscriptSizing="dynamic">
            <mat-label>Markup padrão (%)</mat-label>
            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" [(ngModel)]="markupPadrao" [disabled]="!podeAlterar">
            <mat-icon matSuffix class="help-icon-suffix" matTooltip="Alimenta a variável MARKUP. Um markup próprio no cadastro do produto prevalece sobre este padrão geral.">info_outline</mat-icon>
          </mat-form-field>
        }
      }
    }
  </div>
</div>

@if (!isLoading) {
  <div [matTooltip]="!podeAlterar ? 'Você não possui permissão para salvar alterações nesta configuração.' : ''">
    <app-footer-action [hideCancelar]="true" [isLoadingSalvar]="isLoadingSalvar" [isSalvarDisabled]="!podeAlterar || catalogoIndisponivel || configuracaoIndisponivel || formulas.length === 0" (salvar)="salvar()">
      <span [matTooltip]="!podeAlterar ? 'Você não possui permissão para restaurar estas fórmulas.' : (formulas.length === 0 ? 'Não há fórmulas carregadas para restaurar.' : '')">
        <button mat-stroked-button type="button" class="btn-secondary" (click)="restaurarPadrao()" [disabled]="!podeAlterar || catalogoIndisponivel || configuracaoIndisponivel || formulas.length === 0">Restaurar fórmulas</button>
      </span>
      <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelar()">Cancelar</button>
    </app-footer-action>
  </div>
}
